var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 33,
  fill: "none",
  viewBox: "0 0 33 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D7425A",
  fillRule: "evenodd",
  d: "M16.5 32.5c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16m0-1.745c7.873 0 14.255-6.382 14.255-14.255S24.373 2.245 16.5 2.245 2.245 8.627 2.245 16.5 8.627 30.755 16.5 30.755",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D7425A",
  d: "M16.5 25.955a1.454 1.454 0 1 0 0-2.91 1.454 1.454 0 0 0 0 2.91M17.373 19.99a.873.873 0 0 1-1.746 0V7.19a.873.873 0 1 1 1.746 0z"
})));
export { SvgError32 as ReactComponent };